export default __webpack_public_path__ + "static/media/breadcrumbnext.7d18f539.svg";